import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Container, Card, Button, Form, Alert, Row, Col } from 'react-bootstrap';
import { FaStar } from 'react-icons/fa';

const EncuestaSatisfaccionPage = () => {
    const { idTramite } = useParams();
    const [puntaje, setPuntaje] = useState(0);
    const [hover, setHover] = useState(null);
    const [comentario, setComentario] = useState('');
    const [enviado, setEnviado] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (puntaje === 0) {
            setError('Por favor, selecciona una calificación.');
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api/satisfaccion`, {
                idTramite: parseInt(idTramite, 10),
                puntaje: puntaje,
                comentario: comentario
            });
            setEnviado(true);
            setError(null);
        } catch (err) {
            setError('Hubo un problema al enviar la encuesta. Inténtalo de nuevo más tarde.');
            console.error(err);
        }
    };

    if (enviado) {
        return (
            <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
                <Card className="shadow-lg p-5 text-center" style={{ maxWidth: '600px', borderRadius: '15px' }}>
                    <Card.Body>
                        <h2 style={{ color: '#0075be', marginBottom: '20px' }}>¡Muchas gracias!</h2>
                        <p className="lead text-muted">
                            Tu opinión es fundamental para ayudarnos a mejorar nuestros servicios. 
                            Hemos recibido tu respuesta correctamente.
                        </p>
                    </Card.Body>
                </Card>
            </Container>
        );
    }

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: '20px' }}>
            <Card className="shadow-lg w-100" style={{ maxWidth: '600px', borderRadius: '15px' }}>
                <Card.Body className="p-5">
                    <div className="text-center mb-4">
                        <h2 style={{ color: '#0075be', fontWeight: 'bold' }}>Estudio Jurídico Previsional</h2>
                        <p className="text-muted">Tu Derecho, Nuestra Prioridad</p>
                    </div>

                    <h4 className="text-center mb-4" style={{ color: '#333' }}>¿Cómo calificarías nuestro servicio?</h4>

                    {error && <Alert variant="danger">{error}</Alert>}

                    <Form onSubmit={handleSubmit}>
                        <div className="d-flex justify-content-center mb-4">
                            {[...Array(5)].map((star, i) => {
                                const ratingValue = i + 1;
                                return (
                                    <label key={i} style={{ cursor: 'pointer', margin: '0 10px' }}>
                                        <input
                                            type="radio"
                                            name="rating"
                                            value={ratingValue}
                                            onClick={() => setPuntaje(ratingValue)}
                                            style={{ display: 'none' }}
                                        />
                                        <FaStar
                                            size={50}
                                            color={ratingValue <= (hover || puntaje) ? "#ffc107" : "#e4e5e9"}
                                            onMouseEnter={() => setHover(ratingValue)}
                                            onMouseLeave={() => setHover(null)}
                                            style={{ transition: 'color 200ms' }}
                                        />
                                    </label>
                                );
                            })}
                        </div>

                        <Form.Group className="mb-4">
                            <Form.Label className="text-muted fw-bold">¿Querés dejarnos algún comentario o sugerencia? (Opcional)</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder="Escribe aquí tu opinión..."
                                value={comentario}
                                onChange={(e) => setComentario(e.target.value)}
                                style={{ resize: 'none' }}
                            />
                        </Form.Group>

                        <div className="d-grid">
                            <Button 
                                type="submit" 
                                size="lg" 
                                style={{ backgroundColor: '#0075be', borderColor: '#0075be', fontWeight: 'bold', borderRadius: '10px' }}
                            >
                                Enviar Respuesta
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default EncuestaSatisfaccionPage;
